import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../context/SocketContext'

import { SelectElement } from './selectElement'

import { Form, Navigate, useNavigate } from 'react-router-dom'

const MySwal = withReactContent(Swal);
const sweet = ( title, text, icon ) =>{ MySwal.fire({ title, text, icon, }) }

export const RegistroUsuario = () => {


    const [ modulos, setModulos ] = useState([]);
    const [ moduloSeleccionado, setModuloSeleccionado ] = useState([]);
    const [ usuarioRegistrado, setUsuarioRegistrado ] = useState(null);
    const { socket } = useContext( SocketContext );

    const selectModulo = ( event ) => {
        console.log( event.target.value )

        const entidadingresa = document.getElementById('codigoEntidad');
        const entidad= entidadingresa.value;
        if(entidad === "") return false;

        const usuarioIngreso = document.getElementById('usuario');
        const usuario= usuarioIngreso.value;
        if(usuario === "") return false;

        const passwordIngreso = document.getElementById('password');
        const password= passwordIngreso.value;
        if(password === "") return false;

        const data= { entidad, usuario, password }

        socket.emit( 'select-modulo', data, ( lista ) => {
            // return console.log(ticket)
            if ( lista.length === 0 ) {
                const select = document.getElementById('uidModulo');
                // select.option= '<option value=""> --- </option>';
                sweet("Atención!", 'Revise los datos ingresados', 'error');
            }
            const opciones = lista.map( (item) => ( { value: item.uidModulo, label: `${item.moduloClase} ${item.modulo}` } ) )
            setModulos( opciones );
        })
    }

    const ingresar= () =>{
        
        const entidadingresa = document.getElementById('codigoEntidad');
        const entidad= entidadingresa.value;
        if(entidad === "") return sweet('Atención!', 'Revise la información ingresada');

        const usuarioIngreso = document.getElementById('usuario');
        const usuario= usuarioIngreso.value;
        if(usuario === "") return sweet('Atención!', 'Revise la información ingresada');

        const passwordIngreso = document.getElementById('password');
        const password= passwordIngreso.value;
        if(password === "") return sweet('Atención!', 'Revise la información ingresada');

        // if(moduloSeleccionado === "") return sweet('Atención!', 'Revise la información ingresada');

        const data= { entidad, usuario, password, uidModulo: moduloSeleccionado }

        socket.emit( 'registro-usuario', data, async( respuesta ) => {
            console.log(respuesta)
            if ( respuesta.length === 0 ) return sweet('Atención!', 'Revise la información ingresada');

            localStorage.setItem('uidUsuario', respuesta[0].uidUsuario);
            localStorage.setItem('agente', respuesta[0].nombreCompleto);
            localStorage.setItem('uidModulo', moduloSeleccionado);
            localStorage.setItem('modulo', respuesta[0].modulo === null ? '' : `${respuesta[0].moduloClase} ${respuesta[0].modulo}` );
            localStorage.setItem('entidad', respuesta[0].codigoEntidad);
            localStorage.setItem('imagenLogo', respuesta[0].imagenLogo);
            localStorage.setItem('imagenIcono', respuesta[0].imagenIcono);
             
            setUsuarioRegistrado( respuesta );
            window.location.reload();
           
        })
    }

    useEffect(() => {
      
        socket.on( 'rol-Pantallas', ( lista ) => {
            console.log(lista)
            localStorage.setItem( 'pantallas',  lista.map((item) => item.codigoPantalla ))
        })
    
      return () => {
        socket.off('rol-Pantallas')
        
      }
    }, [socket])
    


  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>

        <div className=" form-group col-6 ">
            <form>

                <div className='col-12 border p-5 rounded-5'>

                    <div className='mb-3'>
                        <label htmlFor="usuario">Usuario</label>
                        <input 
                            type='text'
                            id= 'usuario' 
                            className='shadow form-control '
                            autoComplete='off' 
                            onBlur={event => selectModulo( event ) } 

                        /> 

                    </div>

                    <div className='mb-3'>
                        <label htmlFor="password">Password</label>
                        <input 
                            type='password'
                            id= 'password' 
                            className='shadow form-control '
                            autoComplete='off' 
                            onBlur={event => selectModulo( event ) } 

                        /> 

                    </div>
                    
                    <div className='mb-3'>
                        <label htmlFor="codigoEntidad">Código Entidad</label>
                        <input 
                            type='text'
                            id= 'codigoEntidad' 
                            className='shadow form-control '
                            autoComplete='off'
                            onBlur={event => selectModulo( event ) } 
                        /> 

                    </div>

                    <div className='mb-3'>

                        <label htmlFor="uidModulo">Modulo</label>
                        
                        <SelectElement
                            options= { modulos }
                            name={"uidModulo"}
                            isMulti= {false}
                            closeOnMenuSelect= {true}
                            className= {"shadow p0"}
                            onChange= { (ev) => setModuloSeleccionado(ev.value ) }
                            
                        />
                    
                    
                    </div>

                    <div className='d-grid gap-2'>
                        <button className="btn btn-success btn-lg btn-block shadow" type="button" onClick={ () => ingresar()} >INGRESO</button>
                    </div>

                    
                </div>

            </form>
        </div>

    </div>
  )
}
